import axios from 'axios';
import authHeader from "@/service/auth-header";

function customParamsSerializer(params) {
    let queryString = '';
    const keys = Object.keys(params);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const value = params[key];

        if (value === null || typeof value === 'undefined') {
            continue; // Skip null or undefined parameters
        }

        if (Array.isArray(value)) {
            // If it's an array, append each element as a repeated key=value pair
            value.forEach(item => {
                queryString += `${key}=${encodeURIComponent(item)}&`;
            });
        } else {
            // For non-array values, append as a standard key=value pair
            queryString += `${key}=${encodeURIComponent(value)}&`;
        }
    }

    // Remove the trailing '&' if any
    return queryString.slice(0, -1);
}

class StockDataService {

    async getSpecificStockDataForExchangeAndCode(exchange, code) {
        return await axios.get(`/api/applications/si/stockdata/specific/${exchange}/${code}`, {headers: authHeader()})
    }

    async getAllStockDataForExchange(exchange, type) {
        return await axios.get(`/api/applications/si/stockdata/all/${exchange}/${type}`, {headers: authHeader()})
    }

    async findSectorForExchange(exchange, type) {
        return await axios.get(`/api/applications/si/stockdata/sector/${exchange}/${type}`, {headers: authHeader()})
    }

    async findIndustryForExchange(exchange, type) {
        return await axios.get(`/api/applications/si/stockdata/industry/${exchange}/${type}`, {headers: authHeader()})
    }

    async findDividendTrapForExchange(exchange, type) {
        return await axios.get(`/api/applications/si/stockdata/dividendtrap/${exchange}/${type}`, {headers: authHeader()})
    }

    async getAllStockDataForExchangeLazyLoading(
        exchange, type, params, search, filter, timePeriod, customFilterId) {
        try {
            const newParams = {};

            console.log("[StockDataService][getAllStockDataForExchangeLazyLoading] filter = ", filter);

            if ((filter === "NDSU") || (filter === "NDSO") || (filter === "NDSD")) {
                newParams.sort  = params.sortField || 'siCriteriaYear20Id128';
            } else {
                newParams.sort  = params.sortField || 'yearsDividendIncreasesId047';
            }

            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filter) {
                newParams.filter = filter;
            }

            if (timePeriod) {
                newParams.timePeriod = timePeriod;
            } else {
                newParams.timePeriod = "20";
            }

            if (customFilterId) {
                newParams.customFilterId = customFilterId;
            }

            var apiString = `/api/applications/si/stockdata/all/lazyloading/${exchange}/${type}`;

            console.log("[StockDataService][getAllStockDataForExchangeLazyLoading] ",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filter =", newParams.filter,
                ", timePeriod =", newParams.timePeriod,
                ", customFilterId =", newParams.customFilterId,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data.content,
                totalRecords: response.data.totalElements
            };
        } catch (error) {
            console.error("[StockDataService][getAllStockDataForExchangeLazyLoading] API Error = ", error);
            return {data: [], totalRecords: 0};
        }
    }


    async getStockDataCountsByFilter(exchange, type, search, timePeriod, filterTypes) {
        try {
            const newParams = {};

            if (search) {
                newParams.search = search;
            }

            if (timePeriod) {
                newParams.timePeriod = timePeriod;
            } else {
                newParams.timePeriod = "20";
            }

            if (filterTypes) {
                newParams.filterTypes = filterTypes;
            }

            var apiString = `/api/applications/si/stockdata/count/${exchange}/${type}`;

            console.log("[StockDataService][getStockDataCountsByFilter]",
                ", search =", newParams.search,
                ", timePeriod =", newParams.timePeriod,
                ", filterTypes =", newParams.filterTypes,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams,
                paramsSerializer: customParamsSerializer
            });

            return response.data;
        } catch (error) {
            console.error("[StockDataService][getStockDataCountsByFilter] API Error = ", error);
            return {data: [], totalRecords: 0};
        }
    }

    async getStockDataCountsByFilterNew(exchange, type, search, timePeriod) {
        try {

            var apiString = `/api/applications/si/stockdata/count/new/${exchange}/${type}/${timePeriod}/-`;

            console.log("[StockDataService][getStockDataCountsByFilterNew] ",
                ", search =", search,
                ", timePeriod =", timePeriod,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader()
            });

            return response.data;
        } catch (error) {
            console.error("[StockDataService][getStockDataCountsByFilterNew] API Error = ", error);
            return {data: [], totalRecords: 0};
        }
    }

    async searchStockDataForExchange(exchange, type, criteria) {
        return await axios.get(`/api/applications/si/stockdata/search/${exchange}/${type}/${criteria}`, {headers: authHeader()})
    }

    async searchStockDataForCountryAndSpecificCode(country, type, criteria, params) {

        const newParams = {};

        if (params.sortField) {
            newParams.sortField = params.sortField;
        } else {
            newParams.sortField = "yearsDividendIncreasesId047";
        }

        if (params.sortOrder) {
            newParams.sortOrder = params.sortOrder;
        } else {
            newParams.sortOrder = "desc";
        }

        if (params.customFilterId) {
            newParams.customFilterId = params.customFilterId;
        }

        newParams.page = params.first/params.rows + 1;
        newParams.size = params.rows;

        var apiString = `/api/applications/si/stockdata/search/country/specificcode/${country}/${type}/${criteria}`;

        console.log("[StockDataService][searchStockDataForCountryAndSpecificCode] ",
            "page =", newParams.page,
            ", size =", newParams.size,
            ", sort =", newParams.sortField,
            ", order =", newParams.sortOrder,
            ", customFilterId =", newParams.customFilterId,
            ", API =", apiString);

        const response = await axios.get(apiString, {
            headers: authHeader(),
            params: newParams
        });

        return {
            data: response.data,
            totalRecords: response.totalElements
        };
    }


    async searchStockDataForCountryAndTypeAndAnyCodeExtended(country, type, codes, customFilterId) {

        var apiString = "";
        if (customFilterId != null) {
            apiString = `/api/applications/si/stockdata/search/country/anycode/extended/${country}/${type}/${codes}/${customFilterId}`;
        } else {
            apiString = `/api/applications/si/stockdata/search/country/anycode/extended/${country}/${type}/${codes}`;
        }

        console.log("[StockDataService][searchStockDataForCountryAndTypeAndAnyCodeExtended] ",
            "country =", country,
            ", type =", type,
            ", codes =", codes,
            ", customFilterId =", customFilterId,
            ", API =", apiString);

        const response = await axios.get(apiString, {
            headers: authHeader()
        });

        console.log("[StockDataService][searchStockDataForCountryAndTypeAndAnyCodeExtended] response = ", response);

        return response.data;
    }

    async searchStockDataForCountryAndMultipleCodes(country, type, criteria) {
        return await axios.get(`/api/applications/si/stockdata/search/country/multiplecodes/${country}/${type}/${criteria}`, {headers: authHeader()})
    }

    async processAdvancedSearchForStockData(advancedSearchStockData, params) {

        const newParams = {};

        if (params.sortField) {
            newParams.sortField = params.sortField;
        } else {
            newParams.sortField = "yearsDividendIncreasesId047";
        }

        if (params.sortOrder) {
            newParams.sortOrder = params.sortOrder;
        } else {
            newParams.sortOrder = "desc";
        }

        if (params.customFilterId) {
            newParams.customFilterId = params.customFilterId;
        }

        newParams.page = params.first/params.rows + 1;
        newParams.size = params.rows;

        var apiString = `/api/applications/si/stockdata/advancedsearch`;

        console.log("[StockDataService][processAdvancedSearchForStockData] ",
            "page =", newParams.page,
            ", size =", newParams.size,
            ", sort =", newParams.sortField,
            ", order =", newParams.sortOrder,
            ", customFilterId =", newParams.customFilterId,
            ", API =", apiString);

        const response = await axios.post(apiString, advancedSearchStockData, {
            headers: authHeader(),
            params: newParams
        });

        return {
            data: response.data,
            totalRecords: response.totalElements
        };
    }

    async processAdvancedSearchForStockDataExtended(advancedSearchStockData, customFilterId) {

        var apiString = "";
        if (customFilterId != null) {
            apiString = `/api/applications/si/stockdata/advancedsearch/extended/${customFilterId}`;
        } else {
            apiString = `/api/applications/si/stockdata/advancedsearch/extended`;
        }

        console.log("[StockDataService][processAdvancedSearchForStockDataExtended] ",
            "advancedSearchStockData =", advancedSearchStockData,
            ", customFilterId =", customFilterId,
            ", API =", apiString);


        const response = await axios.post(apiString, advancedSearchStockData, {
            headers: authHeader()
        });

        return response.data;
    }

    async processCustomFilterSearchForStockData(customFilterStockData) {
        return await axios.post(`/api/applications/si/stockdata/customfiltersearch`, customFilterStockData, {headers: authHeader()})
    }

}

export default new StockDataService();
